
// React 
import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';

class ModalRegEmail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showCart: false,
        }
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
    }

    handleClose() {
        this.setState({
            showCart: true
        })
    }
    handleShow() {
        this.setState({
            showCart: true
        })
    }
    render() {
        return (
            <Modal
                show={this.state.showCart}
                onHide={this.handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName="modal-sm"
            >
                <Modal.Header closeButton>
                    <h4>Регистрация</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className="center-block">
                        <b>Вы почти зарегистрированы!</b>
                        <p>На указанный Email было отправлено письмо с дальнейшей инструкцией. Следуйте ей, чтобы  завершить регистрацию.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>ОК</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ModalRegEmail;